import { GalleryItem } from './galleryTypes';

export const toGalleyItems = (imageUrls: string[], videoUrl?: string): GalleryItem[] => {
  const videoItems: GalleryItem[] = videoUrl ? [{ type: 'video', videoUrl }] : [];
  const imageItems: GalleryItem[] = imageUrls.map(imageUrl => ({ type: 'image', imageUrl }));
  return [...videoItems, ...imageItems];
};
